package com.iregained.site.components.sections.home.sections

import androidx.compose.runtime.*
import com.iregained.site.components.sections.home.styles.InvertedPrimaryButtonStyle
import com.iregained.site.components.sections.home.styles.InvertedSecondaryButtonStyle
import com.iregained.site.components.widgets.SharedCtaActionLink
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div

@Composable
fun HomeCtaSection(data: HomeCtaSectionData = defaultHomeCtaSectionData) {
    var isVisible by remember { mutableStateOf(false) }

    if (data.headline.isNotBlank()) {
        Div(attrs = Modifier.fillMaxWidth().toAttrs {
            ref { element ->
                val observer = IntersectionObserver { entries, obs ->
                    entries.forEach {
                        if (it.isIntersecting) {
                            isVisible = true; obs.unobserve(element)
                        }
                    }
                }
                observer.observe(element)
                onDispose { observer.disconnect() }
            }
        }) {
            Box(
                // UNIQUE ANIMATION: The whole CTA block scales up slightly (0.95 -> 1.0)
                modifier = Modifier.fillMaxWidth().opacity(if (isVisible) 1 else 0).scale(if (isVisible) 1f else 0.95f)
                    .transition(
                        Transition.of("opacity", 0.8.s, TransitionTimingFunction.EaseOut),
                        Transition.of("transform", 0.8.s, TransitionTimingFunction.EaseOut)
                    )
            ) {
                SharedCtaWidget(
                    headline = data.headline, description = data.description, actions = {
                        if (data.primaryButtonText.isNotBlank() && data.primaryButtonPath.isNotBlank()) {
                            SharedCtaActionLink(
                                text = data.primaryButtonText,
                                path = data.primaryButtonPath,
                                styleModifier = InvertedPrimaryButtonStyle.toModifier()
                            )
                        }
//                        if (data.secondaryButtonText.isNotBlank() && data.secondaryButtonPath.isNotBlank()) {
//                            SharedCtaActionLink(
//                                text = data.secondaryButtonText,
//                                path = data.secondaryButtonPath,
//                                styleModifier = InvertedSecondaryButtonStyle.toModifier()
//                            )
//                        }
                    })
            }
        }
    }
}


data class HomeCtaSectionData(
    val sectionId: String? = null,
    val headline: String,
    val description: String,
    val primaryButtonText: String,
    val primaryButtonPath: String,
    val secondaryButtonText: String,
    val secondaryButtonPath: String
)

val defaultHomeCtaSectionData = HomeCtaSectionData(
    sectionId = "home-cta",
    headline = "Ready to Take the Next Step?",
    description = "Whether you are a patient seeking recovery or a clinician looking to elevate your practice, our team is here to help.",
    primaryButtonText = "Request a Demo",
    primaryButtonPath = "/contact",
    secondaryButtonText = "Contact Our Team",
    secondaryButtonPath = "/contact"
)